// ToastNotification.js
import React from "react";
import { Snackbar, Alert, Slide } from "@mui/material";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />; // animate in from right
}

const AnimatedSnackbar = ({ open, onClose, message, severity }) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={1000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      TransitionComponent={SlideTransition}
      sx={{
        position: "fixed", // critical to prevent layout shift
        top: 16,
        right: 16,
        zIndex: 1500, // above everything
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          borderRadius: "12px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
          backgroundColor:
            severity === "success"
              ? "#FDF3FD"
              : severity === "error"
              ? "#F1CFD0"
              : severity === "warning"
              ? "#FFF4E5"
              : "#E8F4FD",
          color:
            severity === "success"
              ? "#572575"
              : severity === "error"
              ? "#5F2120"
              : severity === "warning"
              ? "#663C00"
              : "#0D3C61",
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "14px",

          // 🎨 Change icon color here
          "& .MuiAlert-icon": {
            color:
              severity === "success"
                ? "#572575" // purple for success
                : severity === "error"
                ? "#D32F2F" // custom red
                : severity === "warning"
                ? "#ED6C02" // orange
                : "#0288D1", // blue
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AnimatedSnackbar;
